export enum DateType {
	Today = "Today",
	SevenDays = "SevenDays",
	FifteenDays = "FifteenDays",
	ThirtyDays = "ThirtyDays",
	CustomDate = "CustomDate",
}
